import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export default function AvailabilitySummary({ availability }) {
    const data = weekdays.map(day => {
        const slots = availability.filter(s => s.day === day && s.enabled);
        let totalMinutes = 0;
        slots.forEach(slot => {
            const [startH, startM] = slot.start.split(':').map(Number);
            const [endH, endM] = slot.end.split(':').map(Number);
            const start = startH * 60 + startM;
            const end = endH * 60 + endM;
            totalMinutes += Math.max(end - start, 0);
        });
        return {
            day,
            hours: Math.round((totalMinutes / 60) * 100) / 100
        };
    });

    return (
        <div className="card shadow-sm rounded-3" style={{ maxWidth: '618px' }}>
            <div className="card-body p-3">
                <h5 className="card-title text-center mb-4">Weekly Availability (Hours)</h5>
                <div style={{ width: '100%', height: 220 }}>
                    <ResponsiveContainer>
                        <BarChart 
                            data={data} 
                            barCategoryGap="30%" // spacing between bars
                        >
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis dataKey="day" fontSize={12} />
                            <YAxis 
                                label={{ value: 'Hours', angle: -90, position: 'insideLeft', fontSize: 12 }}
                                fontSize={12}
                            />
                            <Tooltip />
                            <Bar 
                                dataKey="hours" 
                                fill="#528b01" 
                                barSize={20} // thinner bars
                                radius={[6, 6, 0, 0]} // rounded top bars
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
}
